import {InvoiceHistoryResponse} from '@mintdata-wsp/common/controllers/network/generated/responses/InvoiceHistoryResponse';
import {PaymentMethodResponse} from '@mintdata-wsp/common/controllers/network/generated/responses/PaymentMethodResponse';
import {ProductOffering} from '@mintdata-wsp/common/controllers/network/generated/responses/ProductOffering';
import {API} from '@mintdata-wsp/common/controllers/network/WorkspaceAPI';

export class BillingController
{
    public getProductOffering():Promise<ProductOffering>
    {
        return API.billing.getProductOffering();
    }

    public getCurrentPaymentMethod():Promise<PaymentMethodResponse>
    {
        return API.billing.getCurrentPaymentMethod();
    }

    public getInvoiceHistory():Promise<InvoiceHistoryResponse>
    {
        return API.billing.getInvoiceHistory();
    }

    // public getInvoice(number:number):Promise<InvoiceResponse> // TODO uncomment
    public getInvoice(number:number):Promise<any> // TODO remove
    {
        // return API.billing.getInvoice(number); // TODO uncomment
        return Promise.resolve({}); // TODO remove
    }
}
